import AppError from '../libraries/AppError';
const PrunePredicateEnum = {
    INCLUDE: 1,
    INCLUDE_AND_PRUNE_CHILDREN: 2,
    EXCLUDE_AND_FLATTEN_CHILDREN: 3,
    EXCLUDE_AND_PRUNE_CHILDREN: 4,
};
const OrderLineOperators = {
    PrunePredicateEnum: PrunePredicateEnum,
    prune(orderLines, predicate, addMenuAdditionFields = false) {
        function recurse(orderLine, newSubLineArray, isParentAMenuAdditionGroup) {
            var _a;
            const pruneDecision = predicate(orderLine);
            const isMenuAddition = ['drinks', 'fries'].includes((_a = orderLine.options) === null || _a === void 0 ? void 0 : _a.groupType);
            if (addMenuAdditionFields && isParentAMenuAdditionGroup) {
                orderLine['_isMenuAdditionPart'] = true;
            }
            if (pruneDecision === PrunePredicateEnum.INCLUDE) {
                const newOrderLine = Object.assign(Object.assign({}, orderLine), { subLines: [] });
                newSubLineArray.push(newOrderLine);
                if (orderLine.subLines && orderLine.subLines.length > 0) {
                    orderLine.subLines.forEach((line) => recurse(line, newOrderLine.subLines, isMenuAddition));
                }
            }
            else if (pruneDecision === PrunePredicateEnum.EXCLUDE_AND_FLATTEN_CHILDREN) {
                orderLine.subLines.forEach((line) => recurse(line, newSubLineArray, isMenuAddition));
            }
            else {
                throw AppError.CodingError()
                    .addData('pruneDecision', pruneDecision)
                    .addData('orderLine', orderLine.name + ' ' + orderLine.id);
            }
        }
        const newOrderLines = [];
        orderLines.forEach((line) => recurse(line, newOrderLines, false));
        return newOrderLines;
    },
};
export default OrderLineOperators;
